/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfListOfOperationalContactPhoneDto } from "../models/AjaxResponseOfListOfOperationalContactPhoneDto";
import type { AjaxResponseOfOperationalContactPhoneDto } from "../models/AjaxResponseOfOperationalContactPhoneDto";
import type { CreateOrUpdateOperationalContactPhoneInput } from "../models/CreateOrUpdateOperationalContactPhoneInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class OperationalContactPhonesAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfListOfOperationalContactPhoneDto Success
   * @throws ApiError
   */
  public getAll({
    contactId,
  }: {
    contactId: number;
  }): CancelablePromise<AjaxResponseOfListOfOperationalContactPhoneDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/operational/contacts/{contactId}/phones",
      path: {
        contactId: contactId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalContactPhoneDto Success
   * @throws ApiError
   */
  public create({
    contactId,
    requestBody,
  }: {
    contactId: number;
    requestBody?: CreateOrUpdateOperationalContactPhoneInput;
  }): CancelablePromise<AjaxResponseOfOperationalContactPhoneDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/operational/contacts/{contactId}/phones",
      path: {
        contactId: contactId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({
    contactId,
    phoneId,
  }: {
    contactId: number;
    phoneId: number;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/operational/contacts/{contactId}/phones/{phoneId}",
      path: {
        contactId: contactId,
        phoneId: phoneId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalContactPhoneDto Success
   * @throws ApiError
   */
  public update({
    contactId,
    phoneId,
    requestBody,
  }: {
    contactId: number;
    phoneId: number;
    requestBody?: CreateOrUpdateOperationalContactPhoneInput;
  }): CancelablePromise<AjaxResponseOfOperationalContactPhoneDto> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/operational/contacts/{contactId}/phones/{phoneId}",
      path: {
        contactId: contactId,
        phoneId: phoneId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
}
